import { Injectable } from '@angular/core';
import { Config } from '@spartacus/core';
import { SeoOptions } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
  useExisting: Config,
})
export abstract class SeoConfig {
  seo?: SeoOptions;
}

export const defaultSeoConfig: SeoConfig = {
  seo: {
    structuredData: {
      disableInDevMode: false,
    },
  },
};
